import * as React from 'react'

const ToIcon = () => (
  <svg width='7' height='9' viewBox='0 0 7 9' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M3.5 0C1.56975 0 0 1.39962 0 3.12067C0 5.06952 2.1525 7.64407 3.5 9C4.84838 7.64407 7 5.06952 7 3.12067C7 1.39962 5.43025 0 3.5 0Z'
      fill='#FF5C47'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M3.5 5C2.67275 5 2 4.32725 2 3.5C2 2.6735 2.67275 2 3.5 2C4.32725 2 5 2.6735 5 3.5C5 4.32725 4.32725 5 3.5 5Z'
      fill='white'
    />
  </svg>
)

export default ToIcon



// WEBPACK FOOTER //
// ./src/components/icons/trips/ToIcon.tsx